import { IDrone } from "@drone-parts.garphild.pro/interfaces";
import { ImageEncoder } from "@mmote/niimbluelib";
import { Button, Space } from "antd";
import LabelCanvas from "./label-canvas";
import { observer } from "mobx-react-lite";
import labelPrinterStorage from "../../../storages/labelPrinterStorage";
import { useEffect, useState } from "react";

function PrintLabel({ drone, qrCode }: { drone: IDrone, qrCode?: string | Promise<string> }) {
  const {
    isPrinterConnected,
    isPrinting,
    btEnabled,
    printLabel,
  } = labelPrinterStorage;

  const [currentQrCode, setCurrentQrCode] = useState<string>('');

  useEffect(() => {
    if (qrCode instanceof Promise) {
      qrCode.then(setCurrentQrCode);
    } else {
      setCurrentQrCode(qrCode || '');
    }
  }, []);

  const canvasId = `canvas-${drone._id}`;

  const printLabelForItem = () => {
    if (!qrCode) {
      return;
    }

    const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
    const image = ImageEncoder.encodeCanvas(canvas, "left");
    printLabel(image, 1);
  };

  const canIPrint = btEnabled && isPrinterConnected && !isPrinting;

  return (
    currentQrCode && <Space direction="vertical">
      <LabelCanvas
        canvasId={canvasId}
        qrCode={currentQrCode || ""}
        text={`GD ${drone.droneNumber}`}
      />
      {canIPrint && <Button disabled={isPrinting} onClick={printLabelForItem}>Print</Button>}
    </Space>
  );
}

export default observer(PrintLabel);
